import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage, socketErrorMessage, SILENT_EVENT_UPDATE } from './wsHelpers';
import {
	updateEvent,
	recordDeletedEvent,
	updateEventPreference,
	updateEventMetadata,
} from '@/redux/actions';

const WS_EVENTS_BY_HTTP = {
	UPDATE: 'event/:eventID/PATCH',
	DELETE: 'event/:eventID/DELETE',
	CREATE_ATTENDEE: 'attendee/POST',
	REMOVE_EVENT: 'attendee/:attendeeID/removeEvent/PATCH',
	UPDATE_NOTIFICATION_PREFERENCE: `event/:eventID/notificationPreferences/PATCH`,
	UPDATE_METADATA: `metadata/:metadataKey/PATCH`,
};

const EventSubscriptions = props => {
	const {
		socket,
		updateEvent,
		recordDeletedEvent,
		updateEventPreference,
		updateEventMetadata,
		children,
	} = props;
	const propsToSend = { ...props };
	const { eventID } = useParams();
	delete propsToSend.children;

	const subscribeToEvent = () => {
		socket.emit('event/:eventID/SUBSCRIBE', { eventID });
	};

	const unsubscribeToEvent = () => {
		socket.emit('event/:eventID/UNSUBSCRIBE', { eventID });
	};

	const listenForUpdatedEvent = () =>
		socket.on(WS_EVENTS_BY_HTTP.UPDATE, payload => {
			const { data, error, from } = payload;
			if (error) {
				const message = socketErrorMessage(error);
				if (message.includes('the number of paid seats')) {
					displayMessage('Unpaid Event Could not be Activated', error);
				} else {
					displayMessage('Event Could not be Updated', error);
				}
			} else {
				updateEvent(data);
				if (from !== SILENT_EVENT_UPDATE) displayMessage('Event Updated');
			}
		});

	const listenForDeletedEvent = () =>
		socket.on(WS_EVENTS_BY_HTTP.DELETE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error while archiving event', error);
			else {
				recordDeletedEvent(data);
				displayMessage('Event archived');
			}
		});

	const listenForUpdatedEventPreference = () =>
		socket.on(WS_EVENTS_BY_HTTP.UPDATE_NOTIFICATION_PREFERENCE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error while updating event notification preference', error);
			else {
				updateEventPreference(data, 'updateEventPreference socket');
				displayMessage('Preference updated');
			}
		});

	const listenForUpdatedEventMetadata = () =>
		socket.on(WS_EVENTS_BY_HTTP.UPDATE_METADATA, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error while updating event metadata', error);
			else {
				updateEventMetadata(data);
				displayMessage('Event Metadata updated');
			}
		});

	const listeners = () => [
		listenForUpdatedEvent,
		listenForDeletedEvent,
		listenForUpdatedEventPreference,
		listenForUpdatedEventMetadata,
	];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribeToEvent}
				unsub={unsubscribeToEvent}
				listeners={listeners()}
				routes={Object.values(WS_EVENTS_BY_HTTP)}
				from="EventSubscriptions"
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
});

const mdp = dispatch => ({
	updateEvent: event => dispatch(updateEvent(event)),
	recordDeletedEvent: event => dispatch(recordDeletedEvent(event)),
	updateEventPreference: (eventPreference, from) =>
		dispatch(updateEventPreference(eventPreference, from)),
	updateEventMetadata: eventMetadata => dispatch(updateEventMetadata(eventMetadata)),
});

export default connect(msp, mdp)(EventSubscriptions);
